function shareCart() {
  //Reads the page 'cart' cookie
  document.getElementById('shareCartId').value = getMerchCookie('cart');

}

function copyCart() {
  //Selects the shareCartId and copies the value
  const cartId = document.getElementById('shareCartId');
  const successMessage = document.getElementById('successMessage')
  cartId.select();
  cartId.setSelectionRange(0, 99999); //For mobile devices
  document.execCommand("copy");
  $('#successMessage').empty().append(`<div class="alert alert-success">Cart ID copied!</div>`);
}

function copyDraftOrderLink() {
  const linkInput = document.getElementById('saveDraftOrderLink');
  if (!linkInput || !linkInput.value) {
    return;
  }
  navigator.clipboard.writeText(linkInput.value);
  const copyMessageEl = document.getElementById('saveDraftOrderCopyMessage');
  if (copyMessageEl) {
    copyMessageEl.innerHTML = '<div class="alert alert-success">Link copied!</div>';
  }
}

function loadCart() {
  $('.sb-errors').html('');
  const cartId = $('#cartIdInput').val();
  
  // Basic validatation Cart ID format
 // if(cartId.length >= 32 && cartId.length <= 35 ) {
 //   $('.sb-errors').html('<div class="alert alert-danger">Invalid Cart ID. Please try again.</div>');
 // }
 // else {
    setCookie('cart', cartId, 14);
    $('#loadCartModal').modal("hide");
    location.reload();
 // }
}

function clearCartAction() {
  eraseCookie('cart');
  location.reload();
}

function onInputFocus(input) {
    $(input).closest('.form-group').removeClass('focused').addClass('focused');
};

function onInputBlur(input) {
    if ( $(input).val().length > 0 ) {
        $(input).closest('.form-group').removeClass('focused').addClass('focused');
    } else {
        $(input).closest('.form-group').removeClass('focused');
    }
};

async function saveDraftOrder(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const defaultLabelText = 'Save Draft Order';
  const button = (event && event.currentTarget) || document.getElementById('saveDraftOrder');
  if (!button || button.dataset.loading === 'true') {
    return;
  }

  const label = button.querySelector('.save-draft-order-label');

  function setLabel(text, resetAfterMs) {
    if (!label) {
      return;
    }

    label.textContent = text;
    if (resetAfterMs) {
      setTimeout(function () {
        label.textContent = defaultLabelText;
      }, resetAfterMs);
    }
  }

  const customerEmail = window.currentCustomerEmail;
  if (!customerEmail) {
    setLabel('No email provided', 3000);
    return;
  }

  const baseUrl = Merchology.Environment.DIGITAL_OCEAN_FUNCTIONS_URL;
  const cartContent = window.cart || (typeof cart !== 'undefined' ? cart : null);
  if (!baseUrl || !cartContent) {
    setLabel('Error saving draft order', 3000);
    return;
  }

  const cartNoteInput = document.querySelector("textarea[name='note']");
  const cartNote = cartNoteInput ? cartNoteInput.value : '';
  const draftOrderCartContent = JSON.parse(JSON.stringify(cartContent));
  draftOrderCartContent.note = cartNote;

  const endpoint = `${baseUrl.replace(/\/$/, '')}/shopify/cart-to-draft-order`;
  const requestPayload = { content: draftOrderCartContent, email: customerEmail };

  button.dataset.loading = 'true';
  setLabel('Saving...');

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestPayload)
    });

    let responseBody = '';
    try {
      responseBody = await response.text();
    } catch (readError) {}

    if (!response.ok) {
      throw new Error(`Failed to save draft order (${response.status})`);
    }

    let data = {};
    if (responseBody) {
      try {
        data = JSON.parse(responseBody);
      } catch (parseError) {
        throw new Error('Failed to parse draft order response');
      }
    }

    const draft = data && data.draftOrder;
    let shareLink = '';
    if (draft) {
      shareLink =
        [draft.shareUrl, draft.url, draft.adminUrl].find(function (u) {
          return typeof u === 'string' && u.length > 0;
        }) || '';
    }
    if (shareLink) {
      const linkInput = document.getElementById('saveDraftOrderLink');
      if (linkInput) {
        linkInput.value = shareLink;
      }
      document.getElementById('saveDraftOrderCopyMessage').innerHTML = '';
      $('#saveDraftOrderModal').modal('show');
      setLabel(defaultLabelText);
      return;
    }
    setLabel('Draft Order Saved', 3000);
  } catch (error) {
    setLabel('Error saving draft order', 3000);
  } finally {
    button.dataset.loading = 'false';
  }
}